import { h } from 'preact';
import style from './style';
import { HeaderV2, ContainerSize } from '@cube/blocks';
import cx from 'classnames';

export default function Container({ parent, ...props }) {
	return  (
		parent ? (
			<ContainerSize height={false}>
				<Cont parent="parent" {...props} />
			</ContainerSize>
		) : <Cont {...props} />
	);
}

const Cont = ({ title, titleIcon, transform = 'capitalize', children, width, theme, ...props }) => (
	<div class={cx(style.container, style[props.parent], props.class, width > 630 && style.wide, style[theme])}>
		<div class={style.shiftedContainer}>
			{title && <HeaderV2 class={style.head} title={title} titleIcon={titleIcon} />}
			{ children }
		</div>
	</div>
);
